import React, { useContext } from 'react';
import { makeStyles, Theme, createStyles, Link } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';

import { LangContext } from '../context/LangContext';
import translations from '../assets/json/translations.json';

interface SamplingSystemAlertProps {
  fullHeight?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: (props: { fullHeight: boolean }) => ({
      width: '100%',
      height: props.fullHeight
        ? `calc(50vh - ${theme.dimensions.navbarHeight}px)`
        : 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: props.fullHeight ? theme.spacing(3) : theme.spacing(6),
      paddingBottom: theme.spacing(3),
    }),
    alertContainer: {
      maxWidth: theme.dimensions.alertWidth,
      width: '100%',
      margin: '0 auto',
    },
  })
);

const SamplingSystemAlert: React.FC<SamplingSystemAlertProps> = ({
  fullHeight = true,
}) => {
  const [lang] = useContext(LangContext);
  const classes = useStyles({ fullHeight });

  return (
    <div className={classes.root}>
      <div className={classes.alertContainer}>
        <Alert severity="info">
          <AlertTitle style={{ fontWeight: 'bold' }}>
            {translations.oldVaccinationSystemPrefix[lang]}
            <Link
              href="https://screening.covid.is"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
            >
              screening.covid.is
            </Link>
            {translations.oldVaccinationSystemSuffix[lang]}
            <Link
              href="https://bolusetningar.is/"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
            >
              bolusetningar.is
            </Link>
            {translations.oldVaccinationSystemEnd[lang]}
          </AlertTitle>
          {translations.contactAdministratorsNotice[lang]}{' '}
          <Link href="mailto:mottaka@landlaeknir.is" color="primary">
            mottaka@landlaeknir.is
          </Link>
        </Alert>
      </div>
    </div>
  );
};

export default SamplingSystemAlert;
